import { render, staticRenderFns } from "./status-edit-modal.vue?vue&type=template&id=25528ca3&scoped=true"
import script from "./status-edit-modal.vue?vue&type=script&lang=js"
export * from "./status-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./status-edit-modal.vue?vue&type=style&index=0&id=25528ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25528ca3",
  null
  
)

export default component.exports